<template>
    <div>
        <!--        <top></top>-->
        <div class="top">
            <ul class="top-list">
                <li class="group" @click="showPopUp('left')">分组浏览</li>
                <li class="sort" @click="showPopUp('right')">排序方式</li>
            </ul>
        </div>
        <div>
            <!--   <ul class="search-ul-list"
                   v-infinite-scroll="loadMore"
                   infinite-scroll-disabled="loading2"
                   infinite-scroll-distance="0">

                   <li v-for="(item,i) in searchList" v-bind:key="item">
                       <p class="title" @click="getLinkDetail(i)">&lt;!&ndash;touchend&ndash;&gt;
                           <span>{{i+1}}</span><span v-html="item.ti">{{item.ti}}</span>
                       </p>
                       &lt;!&ndash; <p class="description">
                          Determination of ofoxacin enantiomers by CE method using a dual chirl selectors system.
                        </p>&ndash;&gt;
                       <p class="common author">
                           <span>作者:</span> <span class="author-a" v-html="item.au">{{item.au}}</span>
                       </p>
                       &lt;!&ndash; <p class="common unit">
                          <span>作者单位:</span><span v-html="item.auAff">{{item.auAff}}</span>
                        </p>&ndash;&gt;
                       <p class="common unit">
                           <span>出处:</span><span v-html="item.database">{{item.database}}</span>
                       </p>
                       &lt;!&ndash;  <p class="common unit">
                           <span>相关链接:</span><a href="">坂本大佬</a><a href="">关紧</a><a href="">是爽</a><a href="">毕萌萌</a>
                         </p>&ndash;&gt;
                   </li>
               </ul>-->
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">
                <li>
                    <p class="count">为您检索到{{ count }}条数据</p>
                </li>
                <li v-for="(item, i) in searchList" v-bind:key="item">
                    <p class="title" @click="getLinkDetail(i)">
                        <!--touchend-->
                        <span class="hold">{{ i + 1 }}，</span><span v-html="item.ti">{{ item.ti }}</span>
                    </p>
                    <!-- <p class="description">
                       Determination of ofoxacin enantiomers by CE method using a dual chirl selectors system.
                     </p>-->
                    <p class="common author">
                        <span class="hold">作者:</span> <span class="author-a" v-html="item.au">{{ item.au }}</span>
                    </p>
                    <!-- <p class="common unit">
                       <span>作者单位:</span><span v-html="item.auAff">{{item.auAff}}</span>
                     </p>-->
                    <p class="common unit">
                        <span class="hold">出处:</span><span v-html="item.database">{{ item.database }}</span>
                    </p>
                    <!--  <p class="common unit">
                        <span>相关链接:</span><a href="">坂本大佬</a><a href="">关紧</a><a href="">是爽</a><a href="">毕萌萌</a>
                      </p>-->
                </li>
            </van-list>
        </div>
        <!--左侧过滤菜单-->
        <md-popup v-model="isPopupShow.left" position="left">
            <div class="md-example-popup md-example-popup-left">
                <div class="dempo">
                    <div class="left-title">分组浏览</div>
                    <div class="md-example-child md-example-child-check md-example-child-check-4">
                        <div class="select-title-box">
                            <div class="select-title" @click="seloctorYearList()">
                                年份
                                <md-icon name="arrow-down" size="lg"></md-icon>
                            </div>
                            <md-check-list v-show="selectYearShow" v-model="year" icon="right" icon-inverse="" :options="yearList" />
                            <p class="kong" v-show="selectYearShow && yearList.length == 0">暂无数据</p>
                        </div>
                        <div class="select-title-box">
                            <div class="select-title" @click="seloctorTypeList()">
                                文献类型
                                <md-icon name="arrow-down" size="lg"></md-icon>
                            </div>
                            <md-check-list v-show="selectTypeShow" v-model="type" icon="right" icon-inverse="" icon-size="24" :options="typeList" />
                            <p class="kong" v-show="selectTypeShow && typeList.length == 0">暂无数据</p>
                        </div>
                    </div>
                </div>
            </div>
        </md-popup>
        <!--右侧排序菜单-->
        <md-popup v-model="isPopupShow.right" position="right">
            <div class="md-example-popup md-example-popup-right">
                <div class="dempo">
                    <div class="left-title">排序方式</div>
                    <div class="md-example-child md-example-child-check md-example-child-check-4">
                        <md-field>
                            <md-check-list v-model="favorites" icon="right" icon-inverse="" icon-size="24" max="1" :options="fruits" />
                        </md-field>
                    </div>
                </div>
            </div>
        </md-popup>
        <!--loading-->
        <!--     <md-activity-indicator v-if="loading" :size="20" :text-size="16" id="loading" vertical>loading...
             </md-activity-indicator>-->
        <div class="tip" v-show="dataNull">暂无结果,点击<span @click="goBack">返回上一页</span></div>
        <div class="tip" v-show="timeout">请求超时,点击<span @click="search">重新请求</span></div>
    </div>
</template>

<script>
//import top from '../components/header'
// import api from '../../request/api'
import { Popup, PopupTitleBar, DropMenu, Field, CheckList, Icon, ActivityIndicator } from "mand-mobile";
// import memoryMixin from "../params/params-memory-mixin";
// import {InfiniteScroll} from 'mint-ui';

export default {
    name: "searchlist",
    components: {
        [Popup.name]: Popup,
        [PopupTitleBar.name]: PopupTitleBar,
        [DropMenu.name]: DropMenu,
        [Field.name]: Field,
        [CheckList.name]: CheckList,
        [Icon.name]: Icon,
        [ActivityIndicator.name]: ActivityIndicator
        // InfiniteScroll,
        // top,
    },
    data() {
        return {
            /*左右侧弹出*/
            isPopupShow: {},
            //骨架背景的加载\
            skeleton2: true,
            //loading
            loading: true,
            loading2: false,
            //左侧菜单的显示隐藏
            selectYearShow: false,
            selectTypeShow: false,
            selectWOSShow: false,
            //左侧选中的值
            year: [],
            type: [],
            wos: [],
            yearList: [],
            typeList: [],
            searchList: [],
            page: 1,
            pageurl: "",
            //右侧排序
            favorites: [],
            fruits: [],
            dataNull: false,
            count: 0,
            timeout: false,
            finished: false
        };
    },
    mounted: function() {
        //获取检索条件的参数
        this.search();
        this.$store.dispatch("actionsHead", { type: true, title: "Web of Science", iconType: true });
    },
    beforeRouteLeave(to, from, next) {
        // 进入C时B正常缓存 当进入的不是C时 this.$destroy()销毁后
        if (to.name === "wosdetail") {
            if (!from.meta.isKeepAlive) {
                from.meta.isKeepAlive = true; // 当我们进入到C时开启B的缓存
            }
            next();
        } else {
            from.meta.isKeepAlive = false;
            this.$vnode.parent.componentInstance.cache = {};
            this.$vnode.parent.componentInstance.keys = [];
            next(); // 当我们前进的不是C时我们让B页面刷新
        }
    },
    methods: {
        search: function() {
            this.timeout = false;
            this.loading = true;
            let data = this.$route.query;
            /*   let url = '';
         for (let item in data) {
             url += (item + '=' + data[item] + '&');
         }
         url = url.slice(0, url.length - 1);*/
            //   api.wosSearch(data.url).then((res) => {
            this.$get("/wos/search?" + data.url).then((res) => {
                if (res.code === 0) {
                    if (res.data.list.length !== 0) {
                        this.searchList = res.data.list;
                        this.pageurl = res.data.pageurl;
                        this.count = res.data.total;
                        // this.favorites.push(res.data.dateSortUrl);
                        for (let item in res.data.publicationyears) {
                            let val = "PublicationYear_" + item.slice(0, item.indexOf("("));
                            this.yearList.push({
                                value: val.trim(),
                                label: item
                            });
                        }
                        for (let item in res.data.documenttypes) {
                            let val = "Publicationbasis_" + item.slice(0, item.indexOf("("));
                            this.typeList.push({
                                value: val.trim(),
                                label: item
                            });
                        }
                        this.fruits.push(
                            { value: res.data.dateSortUrl, label: "日期" },
                            { value: res.data.usageSortUrl, label: "被引频次 " },
                            { value: res.data.citedSortUrl, label: "使用次数" },
                            { value: res.data.relevantSortUrl, label: "相关性" }
                        );
                        this.loading = false;
                        this.finished = false;
                        this.dataNull = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.dataNull = true;
                    }
                } else {
                    this.loading = false;
                    this.dataNull = true;
                    this.finished = true;
                }
            });
        },
        //返回上一页
        goBack: function() {
            this.$router.go(-1);
        },
        showPopUp: function(type) {
            //给属性设置属性或者修改属性 ---实例创建后存在的属性。
            this.$set(this.isPopupShow, type, true);
        },
        seloctorTypeList: function() {
            this.selectTypeShow = !this.selectTypeShow;
        },
        seloctorWOSList: function() {
            this.selectWOSShow = !this.selectWOSShow;
        },
        seloctorYearList: function() {
            this.selectYearShow = !this.selectYearShow;
        },
        //左侧分面检索
        facetSearch: function() {
            this.searchList = [];
            this.loading = true;
            this.dataNull = false;
            this.componentHide("left");
            let url = "";
            if (this.type.length !== 0) {
                for (let i = 0; i < this.type.length; i++) {
                    url += "facetTerm=" + this.type[i] + "&";
                }
            }
            if (this.year.length !== 0) {
                for (let r = 0; r < this.year.length; r++) {
                    url += "facetTerm=" + this.year[r] + "&";
                }
            }
            url = url.substring(0, url.lastIndexOf("&"));
            //   api.wosRefine(url).then((res) => {
            this.$get("/wos/refine?" + url)
                .then((res) => {
                    if (res.code === 0) {
                        this.searchList = res.data.list;
                        this.pageurl = res.data.pageurl;
                        this.count = res.data.total;
                        this.page = res.data.nowpage;
                        this.loading = false;
                        this.dataNull = false;

                        if (res.data.list.length === 0) {
                            this.finished = true;
                        } else {
                            this.finished = false;
                        }
                    } else {
                        this.loading = false;
                        this.dataNull = true;
                        this.finished = true;
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.dataNull = true;
                    this.finished = true;
                });
        },
        //点击关闭左侧弹出
        componentHide: function(type) {
            this.$set(this.isPopupShow, type, false);
        },
        //上拉加载
        loadMore: function() {
            if (this.$route.name === "woslist") {
                if (this.searchList.length !== 0) {
                    this.loading2 = true;
                    this.loading = true;
                    let url = decodeURI(this.pageurl);
                    this.page = this.page + 1;
                    url = url.replace(/{page}/, this.page);
                    //   api.wosNextPage(url).then((res) => {
                    this.$get("/wos/next-page?url=" + url)
                        .then((res) => {
                            if (res.code === 0) {
                                this.searchList = this.searchList.concat(res.data.list);
                                this.loading2 = false;
                                this.loading = false;
                                if (res.data.list.length === 0) {
                                    this.finished = true;
                                } else {
                                    this.finished = false;
                                }
                            } else {
                                this.loading2 = true;
                                this.loading = true;
                                this.finished = true;
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                            this.finished = true;
                        });
                }
            }
        },
        //点击列表的title事件
        getLinkDetail: function(index) {
            let params = {
                link: this.searchList[index].url
            };
            this.$router.push({
                path: "/wosdetail",
                query: params
            });
        },
        //排序
        searchSort: function(newVal) {
            this.searchList = [];
            this.loading2 = true;
            this.loading = true;
            let url = decodeURI(newVal);
            this.componentHide("right");
            //   api.wosNextPage(url).then((res) => {
            this.$get("/wos/next-page?url=" + url)
                .then((res) => {
                    if (res.code === 0) {
                        this.favorites = [];
                        this.fruits = [];
                        this.yearList = [];
                        this.typeList = [];
                        this.year = [];
                        this.type = [];
                        this.searchList = res.data.list;
                        this.pageurl = res.data.pageurl;
                        this.count = res.data.total;
                        for (let item in res.data.publicationyears) {
                            let val = "PublicationYear_" + item.slice(0, item.indexOf("("));
                            this.yearList.push({
                                value: val.trim(),
                                label: item
                            });
                        }
                        for (let item in res.data.documenttypes) {
                            let val = "Publicationbasis_" + item.slice(0, item.indexOf("("));
                            this.typeList.push({
                                value: val.trim(),
                                label: item
                            });
                        }
                        this.fruits.push(
                            { value: res.data.dateSortUrl, label: "日期" },
                            { value: res.data.usageSortUrl, label: "被引频次 " },
                            { value: res.data.citedSortUrl, label: "使用次数" },
                            { value: res.data.relevantSortUrl, label: "相关性" }
                        );
                        this.loading2 = false;
                        this.loading = false;
                        if (res.data.list.length === 0) {
                            this.finished = true;
                        } else {
                            this.finished = false;
                        }
                    } else {
                        this.loading2 = true;
                        this.loading = true;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    },
    watch: {
        year: function(newVal) {
            if (this.year.length !== 0) {
                this.selectYearShow = false;
                this.facetSearch(newVal);
            }
        },
        type: function(newVal) {
            if (this.type.length !== 0) {
                this.selectTypeShow = false;
                this.facetSearch(newVal);
            }
        },
        favorites: function(newVal) {
            if (this.favorites.length !== 0) {
                this.searchSort(newVal);
            }
        }
    }
};
</script>

<style lang="less">
.kong {
    padding: 1rem 0.85333rem !important;
    background: #f7f7f7;
    text-align: center;
}

.top {
    height: 45px;
    width: 100%;
}

.top-list {
    border-bottom: 0.005rem solid #e5e5e5; /*no*/
    display: flex;
    width: 100%;
    height: 45px;
}

.group {
    border-right: 0.005rem solid #e5e5e5; /*no*/
}

.top-list li {
    height: 45px;
    font-size: 16px;
    line-height: 45px;
    width: 50%;
    text-align: center;
    color: #2d5459;
}

.van-list li {
    border-bottom: 0.005rem solid #e5e5e5; /*no*/
    padding: 10px;
}

.title {
    font-size: 16px;
    line-height: 24px;
    color: #33504c;
}

.description {
    font-size: 16px;
    line-height: 30px;
}

.common {
    margin-top: 10px;
    font-size: 16px;
    display: table;
    width: 100%;
    color: #9b9b9b;
}

.hold {
    font-weight: bold;
}

.md-cell-item-body {
    padding: 0;
    font-size: 16px;
    min-height: 60px;
}

.md-cell-item-body p {
    font-size: 16px;
}

.select-title-box > div:nth-child(2) > div > div {
    padding: 0;
    min-height: 60px;

    div p.md-cell-item-title {
        font-size: 16px !important;
        line-height: 30px !important;
    }
}

.common span {
    color: black;
}

.common span a {
    margin-right: 25px;
    text-decoration: underline;
    color: #9b9b9b;
}

.author-a a {
    margin-right: 25px;
    text-decoration: underline;
    color: #9b9b9b;
}

.dempo {
    margin-top: 10px;
    width: 100%;
    // padding: 15px 5%;
    text-align: left;
}

.left-title,
.select-title,
.md-check-list {
    padding: 0 1rem;
}

.left-title {
    line-height: 100px;
    font-size: 16px;
    border-bottom: 0.005rem solid #e5e5e5; /*no*/
}

.select-title {
    position: relative;
    cursor: pointer;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
}

/*左侧AND右侧弹出菜单样式*/
.md-example-child-popup-0 {
    float: left;
    width: 100%;
}

.md-button {
    margin-bottom: 20px;
}

.md-field {
    padding: 0;
}

.md-example-popup {
    position: relative;
    font-size: 16px;
    font-family: DINPro;
    font-weight: 500;
    box-sizing: border-box;
    text-align: center;
    background-color: #fff;
}

.md-example-popup-center {
    padding: 50px;
    /*border-radius :radius-normal;*/
}

.md-example-popup-top {
    width: 100%;
    height: 75px;
    line-height: 75px;
    background: #4a4c5b;
    color: #fff;
}

.md-icon {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
}

.md-icon.icon-font.lg {
    font-size: 1.24rem;
}

.md-example-popup-bottom {
    width: 100%;
    padding: 100px 0;
}

.md-example-popup-bottom p {
    line-height: 50px;
}

.md-example-popup-left,
.md-example-popup-right {
    height: 100%;
    width: 250px;
    display: flex;
}

#loading {
    margin-top: 30px;
}

.tip {
    margin-top: 200px;
    text-align: center;
    font-size: 16px;
}

.tip span {
    text-decoration: underline;
    color: #305359;
}

.count {
    font-size: 16px;
}

/*9b9b9b*/
</style>
